import { DATASETS_STATUSES as statuses } from '@/config/constants'

export const STEP0 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  report_information: {
    check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
    created_date: 'Abril 23, 2021',
    create_hour: '16:21',
    status: 'Parcialmente consultada'
  },
  datasets: [
    {
      id: 1,
      status: statuses.inProgress,
      name: 'Identidad personal',
      sources: '0/5',
      progress: 0,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.inProgress,
      name: 'Antecedentes penales y criminales',
      sources: '0/5',
      progress: 0,
      details: [{
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            title: 'Reporte Policía',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.inProgress,
      name: 'Antecedentes legales',
      sources: '0/5',
      progress: 0,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.inProgress,
      name: 'Antecedentes internacionales',
      sources: '0/5',
      progress: 0,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.inProgress,
      name: 'Historial profesional',
      sources: '0/5',
      progress: 0,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.inProgress,
      name: 'Impuestos y finanzas',
      sources: '0/5',
      progress: 0,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const STEP1 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  report_information: {
    check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
    created_date: 'Abril 23, 2021',
    create_hour: '16:21',
    status: 'Parcialmente consultada'
  },
  datasets: [
    {
      id: 1,
      status: statuses.inProgress,
      name: 'Identidad personal',
      sources: '1/5',
      progress: 18,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.inProgress,
      name: 'Antecedentes penales y criminales',
      sources: '2/5',
      progress: 34,
      details: [{
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            title: 'Reporte Policía',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.inProgress,
      name: 'Antecedentes legales',
      sources: '1/5',
      progress: 20,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.inProgress,
      name: 'Antecedentes internacionales',
      sources: '0/5',
      progress: 5,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.inProgress,
      name: 'Historial profesional',
      sources: '1/5',
      progress: 13,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.inProgress,
      name: 'Impuestos y finanzas',
      sources: '1/5',
      progress: 21,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const STEP2 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  report_information: {
    check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
    created_date: 'Abril 23, 2021',
    create_hour: '16:21',
    status: 'Parcialmente consultada'
  },
  datasets: [
    {
      id: 1,
      status: statuses.inProgress,
      name: 'Identidad personal',
      sources: '2/5',
      progress: 38,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.inProgress,
      name: 'Antecedentes penales y criminales',
      sources: '3/5',
      progress: 51,
      details: [{
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            title: 'Reporte Policía',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.inProgress,
      name: 'Antecedentes legales',
      sources: '2/5',
      progress: 33,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.inProgress,
      name: 'Antecedentes internacionales',
      sources: '3/5',
      progress: 67,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.partiallyFinished,
      name: 'Historial profesional',
      sources: '3/5',
      progress: 68,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.inProgress,
      name: 'Impuestos y finanzas',
      sources: '2/5',
      progress: 35,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const STEP3 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  report_information: {
    check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
    created_date: 'Abril 23, 2021',
    create_hour: '16:21',
    status: 'Parcialmente consultada'
  },
  datasets: [
    {
      id: 1,
      status: statuses.finished,
      name: 'Identidad personal',
      sources: '5/5',
      progress: 100,
      score: 10,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.inProgress,
      name: 'Antecedentes penales y criminales',
      sources: '3/5',
      progress: 51,
      details: [{
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            title: 'Reporte Policía',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.inProgress,
      name: 'Antecedentes legales',
      sources: '3/5',
      progress: 57,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.finished,
      name: 'Antecedentes internacionales',
      sources: '5/5',
      progress: 100,
      score: 6,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.partiallyFinished,
      name: 'Historial profesional',
      sources: '4/5',
      progress: 81,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.inProgress,
      name: 'Impuestos y finanzas',
      sources: '3/5',
      progress: 49,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const STEP4 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  report_information: {
    check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
    created_date: 'Abril 23, 2021',
    create_hour: '16:21',
    status: 'Parcialmente consultada'
  },
  datasets: [
    {
      id: 1,
      status: statuses.finished,
      name: 'Identidad personal',
      sources: '5/5',
      progress: 100,
      score: 10,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.finished,
      name: 'Antecedentes penales y criminales',
      sources: '5/5',
      progress: 100,
      score: 5,
      details: [{
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            title: 'Reporte Policía',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.inProgress,
      name: 'Antecedentes legales',
      sources: '4/5',
      progress: 81,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.finished,
      name: 'Antecedentes internacionales',
      sources: '5/5',
      progress: 100,
      score: 6,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.partiallyFinished,
      name: 'Historial profesional',
      sources: '4/5',
      progress: 92,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.finished,
      name: 'Impuestos y finanzas',
      sources: '5/5',
      progress: 100,
      score: 10,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const STEP5 = {
  check_id: 'CHKdee5197282f8730c37290f6c99a75c8099a75c34',
  created_date: 'Abril 23, 2021',
  create_hour: '16:21',
  status: 'Parcialmente consultada',
  homonymy: 1,
  score: 0.2,
  confidence_level: null,
  profile_information: {
    name: {
      value: 'Luis Alfonso',
      match: 'ID'
    },
    lastname: {
      value: 'Tavera Moreno',
      match: 'ID'
    },
    identification: {
      value: '79819848',
      match: 'nombre'
    },
    country: {
      value: 'Colombia',
      match: 'ID'
    }
  },
  datasets: [
    {
      id: 1,
      status: statuses.finished,
      name: 'Identidad personal',
      sources: '5/5',
      progress: 100,
      score: 10,
      details: [
        {
          id: 1,
          database_name: 'Lugar de votación',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'NUIP', value: '79819848' },
                    { label: 'Departamento', value: 'Bogotá D.C' },
                    { label: 'Municipio', value: 'Bogotá D.C' },
                    { label: 'Puesto', value: 'Chico norte' },
                    { label: 'Dirección', value: 'AV. Cll 100 # 16 - 75' },
                    { label: 'Mesa', value: '29' },
                    { label: 'Fecha inscripción', value: 'Octubre 03, 2008' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_name: 'Procuraduría',
          tables: [
            {
              rows: [
                {
                  cells: [
                    {
                      label: 'Nombre Completo',
                      value: 'LUIS ALFONSO TAVERA MORENO'
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 3,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Policía Nacional',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Nombre completo', value: 'Luis Alfonso Tavera Moreno' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 4,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Afiliados del régimen contributivo y subsidiado',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        },
        {
          id: 5,
          database_id: 'DBIe7a37e8584777ce70de79fe49bcbc657fac89396',
          database_name: 'Situación militar',
          found_first_name: 'Luis Alfonso',
          found_last_name: 'Tavera Moreno',
          result: 'ignored',
          route: 'person',
          severity: 'none',
          tables: [
            {
              rows: [
                {
                  cells: [
                    { label: 'Descripción', value: 'El ciudadano no presenta antecedentes' }
                  ]
                }
              ]
            }
          ]
        }
      ],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 2,
      status: statuses.finished,
      name: 'Antecedentes penales y criminales',
      sources: '5/5',
      progress: 100,
      score: 5,
      details: [{
        id: 3,
        database_name: 'Procesos Judiciales de Colombia',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: 'Abril 20, 2021'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'Pereira'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Centro de Servicios Judiciales'
                  },
                  {
                    label: 'Radicación',
                    value: '66045600006120090014100'
                  },
                  {
                    label: 'Tipo',
                    value: 'Delitos Contra la Vida y la Integridad Personal'
                  },
                  {
                    label: 'Clase',
                    value: 'Homicidio                                         '
                  },
                  {
                    label: 'Año',
                    value: '2009'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Demandados',
                    value: '89003527 - CARLOS ANDRES MANCERA; 15932347 - CARLOS MARIO VILLADA ARANGO; 10007741 - JUAN CARLOS RENTERIA CASTRO; 18532666 - LEO DAN ANTONIO HERRERA SEPULVEDA; 79819848 - LUIS ALFONSO TAVERA MORENO; 9847519 - OSCAR EDUARDO BEDOYA BEDOYA'
                  },
                  {
                    label: 'Demandantes',
                    value: '25007166 - MARIA LUZ DARY ALARCON JARAMILLO; SD0000000019310 - VIVIANA YEPEZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-23'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '6 Oct 2011'
                  },
                  {
                    label: 'Actuación',
                    value: 'SOLICITUD DE PRECLUSION'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6 Oct 2011'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 1,
        database_name: 'Policía Nacional de Colombia',
        tables: [
          {
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'TAVERA MORENO LUIS ALFONSO'
                  },
                  {
                    label: 'Resultado',
                    value: 'NO TIENE ASUNTOS PENDIENTES CON LAS AUTORIDADES JUDICIALES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 2,
        database_name: 'Procuraduría',
        tables: [
          {
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre Completo',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Descripción',
                    value: 'EL CIUDADANO NO PRESENTA ANTECEDENTES'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 3,
        database_name: 'Instituto nacional penitenciario y carcelario',
        tables: [
          {
            rows: [
              {
                cells: [
                  {
                    label: 'Descripción',
                    value: 'El ciudadano no presenta antecedentes'
                  }
                ]
              }
            ]
          }
        ]
      }, {
        id: 3,
        database_name: 'Inhabilidad para trabajar con menores',
        status: 'disabled',
        tables: [
          {
            rows: [
              {
                cells: [
                  {
                    label: 'Descripción',
                    value: 'El ciudadano no presenta antecedentes'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 3,
      status: statuses.finished,
      name: 'Antecedentes legales',
      sources: '5/5',
      progress: 100,
      score: 6,
      details: [{
        id: 1,
        database_name: 'Procesos Judiciales de Colombia por nombre',
        tables: [
          {
            title: 'Proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Consulta',
                    value: '2021-04-22'
                  },
                  {
                    label: 'Visibilidad',
                    value: 'Público'
                  },
                  {
                    label: 'Ciudad',
                    value: 'PEREIRA '
                  },
                  {
                    label: 'Despacho',
                    value: '005 Juzgado Municipal - Civil'
                  },
                  {
                    label: 'Ubicación',
                    value: 'Secretaria'
                  },
                  {
                    label: 'Contenido',
                    value: '1 ORIGINAL CON MEDIDA, TRASLADO Y ARCHIVO'
                  },
                  {
                    label: 'Radicación',
                    value: '66001400300520170050000'
                  },
                  {
                    label: 'Recurso',
                    value: 'Sin Tipo de Recurso'
                  },
                  {
                    label: 'Tipo',
                    value: 'DE EJECUCION'
                  },
                  {
                    label: 'Clase',
                    value: 'Ejecutivo Singular'
                  },
                  {
                    label: 'Año',
                    value: '2017'
                  },
                  {
                    label: 'Demandados',
                    value: '79819848 - LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Demandantes',
                    value: '24789261 - ISABEL CRISTINA TORRES RAMIREZ'
                  },
                  {
                    label: 'Fecha de Actualización',
                    value: '2021-04-22'
                  }
                ]
              }
            ]
          },
          {
            title: 'Actuaciones del proceso',
            rows: [
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '10 Sep 2018'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO TERMINACIÓN POR DESISTIMIENTO TÁCITO LEY 1194/2008'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10 Sep 2018'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO DECRETA MEDIDAS CAUTELARES'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '5 Jun 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'AUTO LIBRA MANDAMIENTO EJECUTIVO'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '5 Jun 2017'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Fecha de Actuación',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Actuación',
                    value: 'REPARTO Y RADICACIÓN'
                  },
                  {
                    label: 'Anotación',
                    value: 'REPARTO Y RADICACION DEL PROCESO REALIZADAS EL JUEVES, 18 DE MAYO DE 2017 CON SECUENCIA: 5148'
                  },
                  {
                    label: 'Fecha Inicia Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha Finaliza Término',
                    value: '18 May 2017'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '18 May 2017'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        id: 2,
        database_name: 'Rama Judicial Consejo Superior de la Judicatura',
        tables: [
          {
            title: 'Informacion General',
            rows: [
              {
                cells: [
                  {
                    label: 'Código Proceso',
                    value: '05034318400120190001400'
                  },
                  {
                    label: 'Tipo Proceso',
                    value: 'DE EJECUCIÓN C.C.'
                  },
                  {
                    label: 'Clase Proceso',
                    value: 'EJECUTIVO'
                  },
                  {
                    label: 'Subclase Proceso',
                    value: 'Ejec. Conciliación o Condena Impuesta en Sentencia'
                  },
                  {
                    label: 'Departamento',
                    value: 'ANTIOQUIA'
                  },
                  {
                    label: 'Ciudad',
                    value: 'ANDES 05034'
                  },
                  {
                    label: 'Corporación',
                    value: 'JUZGADO DE CIRCUITO'
                  },
                  {
                    label: 'Especialidad',
                    value: 'JUZGADO DE CIRCUITO  PROMISCUO DE FAMILIA'
                  },
                  {
                    label: 'Distrito\\Circuito',
                    value: 'ANDES - ANTIOQUIA - ANTIOQUIA'
                  },
                  {
                    label: 'Número Despacho',
                    value: '001'
                  },
                  {
                    label: 'Despacho',
                    value: 'juzgado de circuito - promiscuo de familia 001 andes'
                  },
                  {
                    label: 'Dirección',
                    value: 'Carrera 51 No. 48-66 71'
                  },
                  {
                    label: 'Teléfono',
                    value: '8414495'
                  },
                  {
                    label: 'Correo Electrónico Externo',
                    value: 'jprfandes@cendoj.ramajudicial.gov.co'
                  },
                  {
                    label: 'Fecha Publicación',
                    value: '18/01/2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandante/accionante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDANTE/ACCIONANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1092913415'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'DEISY PAOLA RUIZ CARDONA'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Defensor',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEFENSOR PRIVADO'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'NO'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '1152456187'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'MICHELLE CAÑAS TORO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Demandado/indiciado/causante',
            rows: [
              {
                cells: [
                  {
                    label: 'Tipo Sujeto',
                    value: 'DEMANDADO/INDICIADO/CAUSANTE'
                  },
                  {
                    label: 'Es Emplazado',
                    value: 'SI'
                  },
                  {
                    label: 'Tipo Documento',
                    value: 'CÉDULA DE CIUDADANIA'
                  },
                  {
                    label: 'Número de Identificación',
                    value: '79819848'
                  },
                  {
                    label: 'Nombre(s) y Apellido(S) / Razón Social',
                    value: 'LUIS ALFONSO TAVERA MORENO'
                  },
                  {
                    label: 'Fecha Registro',
                    value: '18-01-2019'
                  }
                ]
              }
            ]
          },
          {
            title: 'Otros',
            rows: null
          },
          {
            title: 'Informacion de Actuaciones',
            rows: [
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '18/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '14/08/2020 11:24:24 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/08/2020 11:21:50 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/08/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '31/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '31/07/2020 2:28:35 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/07/2020 11:38:25 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:01 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:06:00 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '7/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '6/07/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '6/07/2020 10:04:39 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/03/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '28/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '28/02/2020 2:11:03 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '14/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '13/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '13/02/2020 3:24:16 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/02/2020'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/02/2020 4:54:01 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Decide Liquidación De Crédito'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/09/2019 3:42:02 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '3/09/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '3/09/2019 1:54:09 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena Seguir Adelante Ejecucion'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '2/08/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '2/08/2019 12:00:30 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '11/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '10/06/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '10/06/2019 1:26:46 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '9/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Ordena '
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '8/05/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '8/05/2019 11:14:08 a.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '5/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Libra Mandamiento Ejecutivo/Pago'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '4/02/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '4/02/2019 4:37:52 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'NOTIFICACIONES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Fijacion Estado'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '22/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              },
              {
                cells: [
                  {
                    label: 'Ciclo',
                    value: 'GENERALES'
                  },
                  {
                    label: 'Tipo Actuación',
                    value: 'Auto Inadmite / Auto No Avoca'
                  },
                  {
                    label: 'Fecha Actuación',
                    value: '21/01/2019'
                  },
                  {
                    label: 'Fecha de Registro',
                    value: '21/01/2019 3:37:14 p.m.'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 4,
      status: statuses.finished,
      name: 'Antecedentes internacionales',
      sources: '5/5',
      progress: 100,
      score: 6,
      details: [{
        id: 1,
        database_name: 'FBI',
        tables: [
          {
            title: 'Información general',
            rows: [
              {
                cells: [
                  {
                    label: 'Nombre',
                    value: 'LUIS A. GARCIA-LOPEZ'
                  },
                  {
                    label: 'Descripción',
                    value: 'Possession of a Controlled Substance, Possession with Intent to Distribute Controlled Substances, and Possession of Firearm in Furtherance of Drug Trafficking'
                  },
                  {
                    label: 'Precaución',
                    value: ' On February 20, 2019, 75 subjects of the LAS FARC drug-trafficking organization were indicted for drug trafficking and firearms charges. From approximately 2007, members of LAS FARC have been allegedly involved in the large scale distribution of cocaine, crack cocaine, heroin, and marijuana in the Barrio Obrero area of San Juan, Puerto Rico. LAS FARC maintains control over their organization through the use of alleged violence. Luis A. Garcia-Lopez is a leader in the organization and is currently believed to be in the San Juan, Puerto Rico; New York, New York; or Kissimmee, Florida, areas. Luis A. Garcia-Lopez’s twin brother, Jose Luis Garcia-Lopez, is also wanted for his role in the LAS FARC organization.   An arrest warrant was issued on February 20, 2019, by the United States District Court, Judicial District of Puerto Rico, after Garcia-Lopez was charged federally with possession of a controlled substance, possession with intent to distribute controlled substances, and possession of firearm in furtherance of drug trafficking. '
                  },
                  {
                    label: 'Fechas de nacimiento usadas',
                    value: 'April 29, 1976'
                  },
                  {
                    label: 'Lugar de nacimiento',
                    value: 'United States'
                  },
                  {
                    label: 'Clasificación',
                    value: 'Main'
                  },
                  {
                    label: 'Peso mínimo',
                    value: '175'
                  },
                  {
                    label: 'Peso máximo',
                    value: '175'
                  },
                  {
                    label: 'Peso',
                    value: '175 pounds'
                  },
                  {
                    label: 'Altura mínima',
                    value: '64'
                  },
                  {
                    label: 'Altura máxima',
                    value: '64'
                  },
                  {
                    label: 'Ojos',
                    value: 'brown'
                  },
                  {
                    label: 'Cabello',
                    value: 'brown'
                  },
                  {
                    label: 'Sexo',
                    value: 'Male'
                  },
                  {
                    label: 'Raza',
                    value: 'black'
                  },
                  {
                    label: 'Nacionalidad',
                    value: 'United States'
                  },
                  {
                    label: 'Razgos distintivos',
                    value: 'Garcia-Lopez has a scar on his face. He also has tattoos on both arms, his back and right leg.'
                  },
                  {
                    label: 'Alias',
                    value: 'Gemelo- Los Gemelos- Luisito'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 5,
      status: statuses.partiallyFinished,
      name: 'Historial profesional',
      sources: '4/5',
      progress: 100,
      score: 10,
      details: [],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    },
    {
      id: 6,
      status: statuses.finished,
      name: 'Impuestos y finanzas',
      sources: '5/5',
      progress: 100,
      score: 10,
      details: [{
        id: 1,
        database_name: 'Contraloría',
        tables: [
          {
            title: 'Antecedentes Fiscales (Persona Natural)',
            rows: [
              {
                cells: [
                  {
                    label: 'Reportado como responsable fiscal',
                    value: 'No'
                  },
                  {
                    label: 'Código de verificación',
                    value: '79819848210422084944'
                  }
                ]
              }
            ]
          }
        ]
      }],
      explanations: [
        { icon: 'icon-pneuma-profile-bold', text: 'Lugar de nacimiento de la persona.' },
        { icon: 'icon-pneuma-home-bold', text: 'Lugar de residencia y votación' }
      ]
    }
  ]
}

export const steps = [STEP0, STEP1, STEP2, STEP3, STEP4, STEP5]
